import { DateField as BoldDateField, DateFieldProps as BoldDateFieldProps, Omit } from 'bold-ui'
import React from 'react'

import { UseFieldProps, usePecField } from '../hooks/useField'
import { getFieldError } from '../util'

export type DateFieldProps = UseFieldProps<string> & Omit<BoldDateFieldProps, 'name'>

export function DateField(props: DateFieldProps) {
  const { input, meta, ...rest } = usePecField({ parse, format, ...props })

  return <BoldDateField error={getFieldError(meta)} {...input} {...rest} />
}

export const parse = (value: Date): string => {
  if (!value) {
    return null
  }

  const year = ('000' + value.getFullYear()).slice(-4)
  const month = ('0' + (value.getMonth() + 1)).slice(-2)
  const day = ('0' + value.getDate()).slice(-2)

  return `${year}-${month}-${day}`
}

export const format = (value: string): Date => {
  if (!value) {
    return null
  }

  try {
    const dateParts = value.split('-')
    const date = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[2], 10))
    return date && date.getTime() ? date : null
  } catch (err) {
    return null
  }
}
